import React from "react";
import B2BNav from "../Landing/B2BNav";
import B2BFooter from "../Landing/B2BFooter";
import "../Landing/b2b.css";

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <B2BNav />
      <div className="legal-content">
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: January 2025</p>
        </div>
        <div className="legal-body">
          <section>
            <h2>1. Information We Collect</h2>
            <p>
              The Local Intent Company collects information to provide our lead generation services.
              This includes:
            </p>
            <ul>
              <li>Account information (name, email, phone number)</li>
              <li>Payment information (processed securely via Stripe)</li>
              <li>Connected social media account credentials (encrypted)</li>
              <li>Campaign settings and preferences</li>
              <li>Usage data and analytics</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>Provide and improve our lead generation services</li>
              <li>Process payments and manage subscriptions</li>
              <li>Monitor and respond to social media posts on your behalf</li>
              <li>Send service updates and notifications</li>
              <li>Analyze platform performance and optimize results</li>
              <li>Prevent fraud and ensure platform security</li>
            </ul>
          </section>

          <section>
            <h2>3. Data Security</h2>
            <p>
              We implement industry-standard security measures including encryption, secure servers,
              and regular security audits. Connected account credentials are encrypted and stored
              securely. We never share your login information with third parties.
            </p>
          </section>

          <section>
            <h2>4. Data Sharing</h2>
            <p>We do not sell your personal information. We may share data with:</p>
            <ul>
              <li>Payment processors (Stripe) to handle transactions</li>
              <li>Cloud service providers for hosting and infrastructure</li>
              <li>Law enforcement when required by law</li>
            </ul>
          </section>

          <section>
            <h2>5. Cookies and Tracking</h2>
            <p>
              We use cookies and similar technologies to maintain sessions, remember preferences,
              and analyze platform usage. You can control cookie settings in your browser.
            </p>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We retain your data for as long as your account is active. Upon account deletion,
              we remove your personal information within 30 days, except where retention is
              required by law or for legitimate business purposes.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and associated data</li>
              <li>Export your data in a portable format</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2>8. Third-Party Services</h2>
            <p>
              Our platform interacts with third-party social media platforms (Nextdoor, Facebook).
              Your use of those platforms is subject to their respective privacy policies.
              We are not responsible for their data practices.
            </p>
          </section>

          <section>
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this privacy policy periodically. We will notify you of significant
              changes via email or platform notification. Continued use after changes constitutes
              acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>
              For privacy-related questions or to exercise your rights, contact us at: {" "}
              <a href="mailto:support@thelocalintent.company">support@thelocalintent.company</a>
            </p>
          </section>
        </div>
      </div>
      <B2BFooter />
    </div>
  );
};

export default PrivacyPolicy;
